<template>
  <div>
    <div class="block jumbotron jumbotron-full-image">
      <div class="block__content">
        <div class="jumbotron__content">
          <div class="jumbotron__text jumbotron__text--wide">
            <h1
              class="h1 mb-0"
              v-html="$t('pages.newbies.section_1.heading')"
            />
          </div>
          <div class="jumbotron__img mx-auto">
            <img
              :src="require('~/images/newbies-rocket.svg')"
              width="282"
              height="227"
              :alt="$t('pages.newbies.section_1.heading')"
            >
          </div>
        </div>
      </div>
    </div>

    <div class="block block--bottom-sm">
      <div class="block__content">
        <h2
          v-if="$te('pages.newbies.section_2.heading')"
          class="h1 text-center"
        >
          {{ $t("pages.newbies.section_2.heading") }}
        </h2>
        <p
          class="text-center text--xl mw-725 mx-auto"
          v-html="$t('pages.newbies.section_2.text')"
        />
      </div>
    </div>

    <div class="block block--top-sm block--bottom-sm">
      <div class="block__content block__content--with-image">
        <div class="block__text">
          <h2 class="h2">
            <strong> {{ $t("pages.newbies.section_3.heading") }}</strong>
          </h2>
          <ol class="list-numbered">
            <li class="list-numbered__item">
              <div class="list-numbered__text">
                <p v-html="$t('pages.newbies.section_3.step_1')" />
              </div>
            </li>
            <li class="list-numbered__item">
              <div class="list-numbered__text">
                <p
                  class="mb-0"
                  v-html="$t('pages.newbies.section_3.step_2')"
                />
                <p v-html="$t('pages.newbies.section_3.step_3')" />
              </div>
            </li>
            <li class="list-numbered__item">
              <div class="list-numbered__text">
                <strong>{{ $t("pages.newbies.section_3.step_4") }}</strong>
              </div>
            </li>
            <li class="list-numbered__item list-numbered__item--questionmark">
              <div class="list-numbered__text">
                <p class="mb-0">
                  <strong>{{ $t("pages.newbies.section_3.text_1") }}</strong>
                </p>
                <p v-html="$t('pages.newbies.section_3.text_2')" />
                <p><strong v-html="$t('pages.newbies.section_3.text_3')" /></p>
              </div>
            </li>
          </ol>
        </div>
        <div class="block__image block__image--offset">
          <img
            :src="require('~/images/newbies-rocket_people.svg')"
            width="540"
            height="414"
            :alt="$t('pages.newbies.section_3.heading')"
          >
        </div>
      </div>
    </div>
    <div class="block block--top-sm block--bottom-sm">
      <div class="block__content text-center">
        <Button
          :to="PATH_SIGNIN_LOGIN"
          icon="icon icon-invoice-new"
          size="extra-large"
          new-design
          type="warning"
        >
          {{ $t("pages.newbies.section_3.cta") }}
        </Button>
      </div>
    </div>

    <div class="block block--top-sm block--bottom-sm">
      <div class="block__content">
        <div class="white-container--with-padding white-container--with-big-padding mw-820 mx-auto">
          <h2 class="h2 text-center">
            <strong>{{ $t("pages.newbies.section_4.heading") }}</strong>
          </h2>

          <transition
            name="el-fade-in-linear"
            mode="out-in"
          >
            <div
              class="thanks"
              v-if="submitted"
              key="thnaks"
            >
              <p class="icon icon-ares-ok">
                <strong>
                  {{ $t('pages.newbies.form.thankYou.message') }}
                </strong>
              </p>
            </div>
            <Form
              :rules="validationRules"
              :model="resource"
              ref="form"
              class="mw-540 mx-auto"
              v-else
              key="form"
            >
              <Alert
                :title="$t('flashMessages.storeContactFormError')"
                type="error"
                show-icon
                effect="dark"
                v-if="showError"
              />

              <FormSection
                class="form-section"
              >
                <FormGroup
                  spacing="sm"
                  vertical
                  prop="email"
                  :label="$t('pages.newbies.form.email.label')"
                >
                  <TextInput
                    name="email"
                    data-test="email"
                    type="string"
                    v-model="resource.email"
                    :placeholder="$t('pages.newbies.form.email.placeholder')"
                  />
                </FormGroup>
                <FormGroup
                  spacing="sm"
                  prop="message"
                  vertical
                  :label="$t('pages.newbies.form.message.label')"
                >
                  <TextInput
                    name="message"
                    data-test="message"
                    type="textarea"
                    rows="5"
                    v-model="resource.message"
                    :placeholder="$t('pages.newbies.form.message.placeholder')"
                  />
                </FormGroup>
              </FormSection>

              <div class="form-actions text-center">
                <Button
                  type="warning"
                  @click="recaptcha"
                  icon="icon icon-send"
                  size="large"
                >
                  {{ $t('pages.newbies.section_4.cta') }}
                </Button>
              </div>
            </Form>
          </transition>
        </div>
      </div>
    </div>
    <InfoPanel />
    <div
      v-if="$te('pages.newbies.blog.heading')"
      class="block block--top-sm block--bottom-sm"
    >
      <div class="block__content">
        <h3 class="h1 text-center">
          {{ $t("pages.newbies.section_2.heading") }}
        </h3>
        <HpBlogposts
          :posts-count="3"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  PATH_SIGNIN_LOGIN, PATH_INVOICE,
} from '~/router';

import { SUBMIT_CONTACT_MUTATION } from '~/mutations';

import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

export default {
  name: 'NewBies',
  components: {
    HpBlogposts: () => import('~/components/HpBlogposts.vue'),
    InfoPanel: () => import('~/components/InfoPanel.vue'),
  },
  data() {
    return {
      PATH_SIGNIN_LOGIN,
      PATH_INVOICE,
      resource: {
        email: null,
        message: null,
      },
      submitted: false,
      showError: false,
    };
  },
  computed: {
    validationRules() {
      return {
        email: [
          {
            required: true,
            message: 'email_required',
          },
          {
            type: 'email',
            message: 'email_format',
          },
        ],
        message: [
          {
            required: true,
            message: 'message_required',
          },
        ],
      };
    },
  },
  methods: {
    async recaptcha() {
      await this.$recaptchaLoaded();

      const token = await this.$recaptcha('contact_form');

      this.submit(token);
    },
    submit(token) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$apollo.mutate({
            mutation: SUBMIT_CONTACT_MUTATION,
            variables: {
              email: this.resource.email,
              message: this.resource.message,
              token,
              action: 'contact_form',
            },
          }).then((response) => {
            this.submitted = response.data.contactForm.success;
          }).catch(() => {
            this.showError = true;
          });
        }
      });
    },
  },
  created() {
    Vue.use(VueReCaptcha, { siteKey: process.env.RECAPTCHA_SITE_KEY || 'developmentKey' });
  },
};
</script>

<style lang="scss" scoped>
:deep() {
  .blog-cart__content {
    background: transparent !important;
  }
}
</style>
